import React, { useState, useEffect } from 'react'

const DraggableTable = ({
  id,
  rows,
  cols,
  cellHeight,
  cellWidth,
  alignment,
  isAlignment,
  onTableSelect,
  handleDragStart,
  handleDragOver,
  fontSize, // Font size prop
  isTableSelected, // Prop to indicate if the table is selected
  setTableAlignment, // Function to set the alignment of the selected table
  onCellClick, // Callback function to handle cell click
  isBold,
  isItalic,
  isUnderline,
  cellAlignment,
}) => {
  const [position, setPosition] = useState({ left: 0, top: 0 })
  const [isDragging, setIsDragging] = useState(false)
  const [borderColor, setBorderColor] = useState(isTableSelected ? 'red' : 'black')
  const initialCellData = Array.from({ length: rows }, () =>
    Array.from({ length: cols }, () => ({
      content: '',
      font: 'Arial, sans-serif',
      fontSize,
      fontWeight: 'normal',
      isBold: false,
      isItalic: false,
      isUnderline: false,
      isSelected: false,
      textAlignment: 'left',
    }))
  )
  const [cellData, setCellData] = useState(initialCellData)

  // useEffect(() => {
  //   setCellData((prevCellData) =>
  //     prevCellData.map((row) =>
  //       row.map((cell) => ({
  //         ...cell,
  //         fontSize,
  //       }))
  //     )
  //   )
  // }, [fontSize])
  useEffect(() => {
    setCellData((prevCellData) =>
      prevCellData.map((row) =>
        row.map((cell) => ({
          ...cell,
          isBold: cell.isSelected ? isBold : cell.isBold,
          isItalic: cell.isSelected ? isItalic : cell.isItalic,
          isUnderline: cell.isSelected ? isUnderline : cell.isUnderline,
          alignment: cell.isSelected ? cellAlignment : cell.cellAlignment,
        }))
      )
    )
  }, [isBold, isItalic, isUnderline, alignment])
  const handleMouseDown = (e) => {
    setIsDragging(true)
    const initialLeft = e.clientX - position.left
    const initialTop = e.clientY - position.top

    const handleMouseMove = (e) => {
      if (isDragging) {
        const newLeft = e.clientX - initialLeft
        const newTop = e.clientY - initialTop
        setPosition({ left: newLeft, top: newTop })
      }
    }

    const handleMouseUp = () => {
      setIsDragging(false)
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }

    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)
  }

  const handleTableClick = () => {
    onTableSelect(!isTableSelected)
    setBorderColor(isTableSelected ? 'red' : 'black')
  }

  const handleCellDoubleClick = (e, rowIndex, colIndex) => {
    const td = e.target
    td.contentEditable = true
    td.focus()
  }

  const handleCellBlur = (e, rowIndex, colIndex) => {
    const td = e.target
    td.contentEditable = false
    // Update cell content in the state
    const newCellData = [...cellData]
    newCellData[rowIndex][colIndex].content = td.innerText
    setCellData(newCellData)
  }

  const handleCellInput = (e) => {
    // You can handle the input event if needed
    // For example, you may want to update the state with the entered text
  }
  const handleCellClick = (rowIndex, colIndex) => {
    const newCellData = [...cellData]
    newCellData[rowIndex][colIndex].isSelected = !newCellData[rowIndex][colIndex].isSelected
    newCellData[rowIndex][colIndex].fontSize = isTableSelected ? fontSize : newCellData[rowIndex][colIndex].fontSize
    setCellData(newCellData)

    // Invoke the callback function from the parent component
    if (onCellClick) {
      onCellClick(rowIndex, colIndex, newCellData[rowIndex][colIndex])
    }
  }

  return (
    <div
      draggable
      onDragStart={(e) => handleDragStart(e)}
      onDragOver={(e) => handleDragOver(e)}
      onDrop={(e) => e.preventDefault()}
      id={id}
      style={{
        position: 'absolute',
        left: !isAlignment ? position.left + 'px' : alignment === 'center' ? '50%' : alignment === 'right' ? 'auto' : '10px',
        right: !isAlignment ? '' : alignment === 'right' ? '10px' : 'auto',
        top: position.top + 'px',
        transform: !isAlignment ? '' : alignment === 'center' ? 'translate(-50%, -50%)' : 'translate(0, -50%)',
        // border: `1px solid ${borderColor}`,
        cursor: isDragging ? 'grabbing' : 'grab',
      }}
      onMouseDown={handleMouseDown}
      onClick={handleTableClick}
    >
      <table style={{ borderCollapse: 'collapse' }}>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: cols }).map((_, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    height: cellHeight + 'px',
                    width: cellWidth + 'px',
                    border: '1px solid black',
                    padding: '4px', // Add padding for better appearance
                    position: 'relative',
                    fontFamily: cellData[rowIndex][colIndex].font,
                    fontSize: cellData[rowIndex][colIndex].fontSize,
                    fontWeight: cellData[rowIndex][colIndex].fontWeight,
                    textAlign: isTableSelected ? alignment : 'left',
                    textDecoration: cellData[rowIndex][colIndex].isUnderline ? 'underline' : 'none',
                    fontStyle: cellData[rowIndex][colIndex].isItalic ? 'italic' : 'normal',
                    fontWeight: cellData[rowIndex][colIndex].isBold ? 'bold' : 'normal',
                    backgroundColor: cellData[rowIndex][colIndex].isSelected ? 'rgb(242 249 255)' : 'white',
                  }}
                  onDoubleClick={(e) => handleCellDoubleClick(e, rowIndex, colIndex)}
                  onBlur={(e) => handleCellBlur(e, rowIndex, colIndex)}
                  onInput={handleCellInput}
                  onClick={() => handleCellClick(rowIndex, colIndex)} // Handle cell click
                >
                  {cellData[rowIndex][colIndex].content}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DraggableTable
